import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Alert, Col, Divider, Row, notification } from 'antd'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'

import updateProrateAllowances, {
  ProrateAllowancesValues,
} from 'core/application/adminDashboard/benefitDetails/design/prorateAllowances'

import Radio from 'common/components/dataEntry/formik/FormikRadioField'

import { commandRequest } from 'common/RequestUtils'

import { BaseComponentProps } from '../../../../common/productClassWizardModal/Common'

const formValidator = (translate: any) => Yup.object({})

const ProrateAllowances: React.FC<BaseComponentProps<ProrateAllowancesValues>> = (props) => {
  const { bindSubmitFormHandler } = props
  const { t: translate } = useTranslation()
  const { planPeriod } = useParams<any>()

  useEffect(() => {
    props.setIsFormValid(formValidator(translate).isValidSync(props.state))
  }, [])

  const onSubmit = async (values: ProrateAllowancesValues) => {
    var request = { ...values, planPeriodId: planPeriod }
    console.log(request)
    let result = await commandRequest(() => updateProrateAllowances(request))

    if (!result.errors) {
      props.finish()
    } else {
      props.setIsSubmiting(false)
      notification.open({
        message: result.errors[0],
        type: 'error',
      })
    }
  }
  return (
    <Formik
      enableReinitialize={true}
      validationSchema={formValidator(translate)}
      initialValues={props.state}
      onSubmit={onSubmit}
      validate={(values) => {
        const isValid: boolean = formValidator(translate).isValidSync(values)
        props.setHasDirtyData(isValid)
        props.setIsFormValid(isValid)
        return {}
      }}
    >
      {(formik) => {
        const { handleSubmit, submitForm } = formik
        bindSubmitFormHandler(submitForm)
        return (
          <Form>
            <Row>
              <h5>{translate('admin-dashboard.benefit-details.class-design.prorate-allowances-hire.header')}</h5>
            </Row>
            <Row className="mb-16 pt-16">
              <Col span={22} className="pl-8 pr-8">
                <Alert
                  showIcon
                  type="info"
                  message={translate(
                    'admin-dashboard.benefit-details.class-design.prorate-allowances-hire.alert-header',
                  )}
                  description={translate(
                    'admin-dashboard.benefit-details.class-design.prorate-allowances-hire.alert-desc',
                  )}
                ></Alert>
              </Col>
            </Row>
            <Row gutter={10}>
              <Col span={22}>
                <Radio.Group name="prorateAllowancesHire" defaultValue={props.state.prorateAllowancesHire}>
                  <Row gutter={10}>
                    <Col span={12}>
                      <Radio.Button
                        className="custom-medium radio-with-checkmark cost_sharing_amount__radio"
                        value={false}
                      >
                        <div className="pl-16 pr-24 content">
                          <h5 className="option_title">
                            {translate('admin-dashboard.benefit-details.class-design.prorate-allowances-hire.no')}
                          </h5>
                        </div>
                      </Radio.Button>
                    </Col>
                    <Col span={12}>
                      <Radio.Button
                        className="custom-medium radio-with-checkmark cost_sharing_amount__radio"
                        value={true}
                      >
                        <div className="pl-16 pr-24 content">
                          <h5 className="option_title">
                            {translate('admin-dashboard.benefit-details.class-design.prorate-allowances-hire.yes')}
                          </h5>
                        </div>
                      </Radio.Button>
                    </Col>
                  </Row>
                </Radio.Group>
              </Col>
            </Row>
            <Divider />
            <Row>
              <h5>{translate('admin-dashboard.benefit-details.class-design.prorate-allowances.header')}</h5>
            </Row>
            <Row className="mb-16 pt-16">
              <Col span={22} className="pl-8 pr-8">
                <Alert
                  showIcon
                  type="info"
                  message={translate('admin-dashboard.benefit-details.class-design.prorate-allowances.alert-header')}
                  description={translate('admin-dashboard.benefit-details.class-design.prorate-allowances.alert-desc')}
                ></Alert>
              </Col>
            </Row>
            <Row>
              <Col span={22}>
                <Radio.Group name="prorateAllowancesTerminate" defaultValue={props.state.prorateAllowancesTerminate}>
                  <Row gutter={10}>
                    <Col span={12}>
                      <Radio.Button
                        className="custom-medium radio-with-checkmark cost_sharing_amount__radio"
                        value={false}
                      >
                        <div className="pl-16 pr-24 content">
                          <h5 className="option_title">
                            {translate('admin-dashboard.benefit-details.class-design.prorate-allowances.doNotProrate')}
                          </h5>
                        </div>
                      </Radio.Button>
                    </Col>
                    <Col span={12}>
                      <Radio.Button
                        className="custom-medium radio-with-checkmark cost_sharing_amount__radio"
                        value={true}
                      >
                        <div className="pl-16 pr-24 content">
                          <h5 className="option_title">
                            {translate(
                              'admin-dashboard.benefit-details.class-design.prorate-allowances.reduceAllowances',
                            )}
                          </h5>
                        </div>
                      </Radio.Button>
                    </Col>
                  </Row>
                </Radio.Group>
              </Col>
            </Row>
          </Form>
        )
      }}
    </Formik>
  )
}

export default ProrateAllowances
